import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=2b5ab69c&"
import script from "./ReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewDialog.vue?vue&type=style&index=1&id=2b5ab69c&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5ab69c')) {
      api.createRecord('2b5ab69c', component.options)
    } else {
      api.reload('2b5ab69c', component.options)
    }
    module.hot.accept("./ReviewDialog.vue?vue&type=template&id=2b5ab69c&", function () {
      api.rerender('2b5ab69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/ReviewDialog.vue"
export default component.exports